<template>
    <transition name="modal">
        <div class="modal-mask" :class="modalclass" @click="(clickoutside) ? $emit('close') : ''">
            <div class="modal-wrapper">
                <div class="modal-container-full position-relative bg-white" @click="clickoutside ? handleClick($event) : null">
                  <div class="close-icon-top-right" @click="$emit('close')">
                    <span class="label-style">Close</span>
                    <close-icon class="ml-2"></close-icon>
                  </div>
                    <div class="modal-body">
                        <slot name="body">
                            default body
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Close from "../Icons/member.vue";
    import CloseIcon from "../Icons/close.vue";

    export default {
      components: {CloseIcon, Close},
        props: ['modalclass', 'clickoutside'],
        methods: {
            handleClick: function(e) {
                e.stopPropagation();
            }
        }
    }
</script>

<style scoped>
  .modal-container-full {
    width: 80%;
    height:80%;
    margin: 0 auto;
  }
  .modal-body {
    position: absolute;
    overflow: scroll;
    height: 90%;
    width: 100%;
  }
  .close-icon-top-right {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 1;
  }
  .close-icon-top-right .label-style {
    color: #f1ad14;
  }
  .close-icon-top-right:hover .label-style {
    color: #336aa4;
  }
  .close-icon-top-right svg path {
    fill: #f1ad14;
  }
  .close-icon-top-right:hover svg path {
    fill: #336aa4;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 400px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    max-height: 94vh;
    overflow: scroll;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #363636;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }
</style>
